import React from 'react';

import { SHARE_PERMISSION_EDIT, SHARE_PERMISSION_VIEW } from '../../constants';

/**
 * Height of one person row; react-window needs it fixed to virtualize.
 */
export const ROW_HEIGHT = 52;

/**
 * Coerces a select value to a known permission.
 *
 * @param {string} value - Raw select value.
 * @returns {string}
 */
export function toPermission(value) {
    return value === SHARE_PERMISSION_EDIT ? SHARE_PERMISSION_EDIT : SHARE_PERMISSION_VIEW;
}

/**
 * One virtualized person row in the share dialog: a checkbox to include them
 * and their view/edit access.
 *
 * @param {Object} props - Row props from react-window plus rowProps.
 * @returns {React$Element}
 */
export default function NotesSharePerson({ ariaAttributes, draft, index, onPermission, onToggle, rows, style, t }) {
    const { id, name } = rows[index];
    const checked = draft.ids.includes(id);

    return (
        <div
            { ...ariaAttributes }
            className = 'notes_pane-share-row'
            style = { style }>
            <label>
                <input
                    checked = { checked }
                    onChange = { () => onToggle(id) }
                    type = 'checkbox' />
                <span
                    aria-hidden = 'true'
                    className = 'notes_pane-share-avatar'>{Array.from(name.trim())[0]?.toUpperCase()}</span>
                <span
                    className = 'notes_pane-share-name'
                    title = { name }>{name}</span>
            </label>
            <select
                aria-label = { t('notesPane.accessForName', { name }) }
                disabled = { !checked }
                onChange = { event => onPermission(id, event.target.value) }
                value = { draft.permissions[id] || SHARE_PERMISSION_VIEW }>
                <option value = { SHARE_PERMISSION_VIEW }>{t('notesPane.canView')}</option>
                <option value = { SHARE_PERMISSION_EDIT }>{t('notesPane.canEdit')}</option>
            </select>
        </div>
    );
}
